import type { TabsProps } from 'antd';
import { observer } from "mobx-react-lite";
import { Fragment} from "react";
import {
  Col,
  Form,
  Modal,
  Row,
  Tabs,
  Table,
} from "antd";
import { CallManageStore } from '../../../store'
import "./index.css";
function RowDetail() {
  const form = Form.useFormInstance();
  const { Column } = Table;
  const getFormData = (changeValue: any, allValues: any) => {
    allValues.displayName = CallManageStore.lookPower.displayName;
    CallManageStore.setLookPower(allValues);

  };
  //详情tab切换数据
  const handleModeChange = (value: string) => {
    CallManageStore.resetDetails()
    CallManageStore.status = value
    CallManageStore.detailsData.taskRecordDetails = []
    CallManageStore.getTaskDetails(CallManageStore.taskRecordDetails)
  };
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: '已完成',
    },
    {
      key: '2',
      label: '进行中',
    },
    {
      key: '3',
      label: '待进行',
    },
  ];
  return (
    <Fragment>
      <div className="allContent">
        <div className="formContent">
          <Modal
            width={"900px"}
            centered
            title={'任务详情'}
            open={CallManageStore.isDetailOpen}
            destroyOnClose={true}
            onCancel={() => CallManageStore.onOpenFalse()}
            footer={null}
          >
            <Row className="details-top">
              <Col span={24}>
                <div className="details-name">
                  <div><span>任务名称: {CallManageStore.detailsData.taskName}</span> <span>任务进度: {Math.round(CallManageStore.detailsData.finishRate * 100)}%</span> </div>
                  <div><span>任务话术: {CallManageStore.detailsData.scriptName}</span> <span>任务并发: {CallManageStore.detailsData.concurrency}</span>
                    <span>任务时间:{CallManageStore.detailsData.beginTime}~{CallManageStore.detailsData.endTime}</span></div>
                  <div>
                 <span>禁播时间:
                    {CallManageStore.detailsData.forbidTimeFormat == null && '未配置'}
                     {CallManageStore.detailsData.forbidTimeFormat &&
                      CallManageStore.detailsData.forbidTimeFormat.map((item: {
                        end: any;
                        start: any; week: any; }) => (
                        <span>{ `${item.week=='W1'?'周一':item.week=='W2'?'周二':item.week=='W3'?'周三':item.week=='W4'?'周四':item.week=='W5'?'周五':item.week=='W6'?'周六':'周日'} ${item.start}-${item.end}`}</span>
                      ))}</span>
                  </div>
                </div>
              </Col>
              <div className="card-flex">
                <div className="card-blxSKV">
                  <div className="card-blxSKV-name">呼叫接通率</div>
                  <div className="card-blxSKV-data">{Math.round(CallManageStore.detailsData.throughRate * 100)}%</div>
                </div>
                <div className="card-blxSKV">
                  <div className="card-blxSKV-name">呼叫数</div>
                  <div className="card-blxSKV-data">{CallManageStore.detailsData.calledSize}</div>
                </div>
                <div className="card-blxSKV">
                  <div className="card-blxSKV-name">接通数</div>
                  <div className="card-blxSKV-data">{CallManageStore.detailsData.throughSize}</div>
                </div>
              </div>
            </Row>
            <Tabs defaultActiveKey="1" items={items} onChange={handleModeChange} />
            <Table
              dataSource={CallManageStore.detailsData.taskRecordDetails}
              rowKey={(record) => record.mainCallId}
              loading={CallManageStore.taskRecordTableLoad}
              scroll={{ x: 900,y: 'calc(100vh - 500px)' }}
              pagination={{
                current: CallManageStore.DetailspageData.page,
                pageSize: CallManageStore.DetailspageData.size,
                onChange: CallManageStore.DetailspageData.changePage,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                total: CallManageStore.detailsData.total,
                showTotal: () =>
                  `共计${CallManageStore.detailsData.total}条`,
                position: ["bottomLeft"],
              }}
            >
              <Column
                ellipsis={true}
                width={50}
                title="被叫号码"
                dataIndex="phone"
              />
              <Column
                ellipsis={true}
                width={50}
                title="通话状态"
                dataIndex="callResultStr"
              />
              <Column
                ellipsis={true}
                width={50}
                title="拨打次数"
                dataIndex="callTimes"
              />
              <Column
                ellipsis={true}
                width={50}
                title="通话时长"
                dataIndex="durationInMsStr"
              />
              <Column
                ellipsis={true}
                width={50}
                title="主叫号码"
                dataIndex="explicitNumber"
              />
            </Table>
          </Modal>
        </div>
      </div>
    </Fragment>
  );
}

export default observer(RowDetail);
